import React from 'react';
import { common } from '@kurtosys/ksys-app-template';
import { observer } from 'mobx-react';

import { ComponentBase } from '../../../shared/ComponentBase.js';
import { InjectedStyledComponent } from '../../../shared/InjectedStyledComponent.js';
import Button from '../Button/Button.js';
import { IButtonProps } from '../Button/models/index.js';
import { IRedirectButtonProps } from '../RedirectButton/models/index.js';
import RedirectButton from '../RedirectButton/RedirectButton.js';

import { IActionsConfiguration, IActionsProps, IActionsState } from './models/index.js';
import Wrapper from './styledComponents/Wrapper.js';
import { ACTIONS_CATEGORY_KEY, ACTIONS_COMPONENT_KEY } from './Actions.meta.js';

export class Actions extends ComponentBase<IActionsProps, IActionsState, IActionsConfiguration> {
	categoryKey = ACTIONS_CATEGORY_KEY;
	componentKey = ACTIONS_COMPONENT_KEY;
	constructor(props: IActionsProps) {
		super(props);
	}
	isRedirectButton(props: IButtonProps | IRedirectButtonProps): boolean {
		const redirect = common.commonUtils.get(props, 'redirect');
		return !common.commonUtils.isNullOrUndefined(redirect);
	}
	render() {
		const { className, buttons = [], analyticsContext, suppressAnalytics } = this.props;
		return (
			<Wrapper className={className}>
				{buttons.map((buttonProps, index) => {
					const key = `button_${index}`;
					return this.isRedirectButton(buttonProps) ? (
						<RedirectButton
							key={key}
							analyticsContext={analyticsContext}
							suppressAnalytics={suppressAnalytics}
							{...buttonProps}
						/>
					) : (
						<Button
							key={key}
							analyticsContext={analyticsContext}
							suppressAnalytics={suppressAnalytics}
							{...buttonProps}
						/>
					);
				})}
			</Wrapper>
		);
	}
}

export default InjectedStyledComponent(observer(Actions), ACTIONS_CATEGORY_KEY, ACTIONS_COMPONENT_KEY);
